<template>
    <div class="svg-container" :style="`--width:${width || '64px'}; --height:${height || '64px'};`">
        <svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
          <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
        </svg>
    </div>
</template>
<script type="text/javascript">
	// import helper from './../helpers';

	export default {
		name: 'Loader',
		props: ['width','height'],
		data() {
			return {}
		}
	}
</script>
<style scoped>
    .svg-container {
        width: var(--width);
        height: var(--height);
    }

    .spinner {
        -webkit-animation: rotator 1.4s linear infinite;
          animation: rotator 1.4s linear infinite;
}

@-webkit-keyframes rotator {
  0% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(270deg);
            transform: rotate(270deg);
  }
}

@keyframes rotator {
  0% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(270deg);
            transform: rotate(270deg);
  }
}
.path {
  stroke-dasharray: 187;
  stroke-dashoffset: 0;
  -webkit-transform-origin: center;
      -ms-transform-origin: center;
          transform-origin: center;
  -webkit-animation: dash 1.4s ease-in-out infinite, colors 5.6s ease-in-out infinite;
          animation: dash 1.4s ease-in-out infinite, colors 5.6s ease-in-out infinite;
}

@-webkit-keyframes colors {
  0% {
    stroke: red;
  }
  14.285714286% {
    stroke: orange;
  }
  28.571428572% {
    stroke: yellow;
  }
  42.857142858% {
    stroke: green;
  }
  57.142857144% {
    stroke: blue;
  }
  71.42857143% {
    stroke: indigo;
  }
  100% {
    stroke: violet;
  }
}

@keyframes colors {
  0% {
    stroke: red;
  }
  14.285714286% {
    stroke: orange;
  }
  28.571428572% {
    stroke: yellow;
  }
  42.857142858% {
    stroke: green;
  }
  57.142857144% {
    stroke: blue;
  }
  71.42857143% {
    stroke: indigo;
  }
  100% {
    stroke: violet;
  }
}
@-webkit-keyframes dash {
  0% {
    stroke-dashoffset: 187;
  }
  50% {
    stroke-dashoffset: 46.75;
    -webkit-transform: rotate(135deg);
            transform: rotate(135deg);
  }
  100% {
    stroke-dashoffset: 187;
    -webkit-transform: rotate(450deg);
            transform: rotate(450deg);
  }
}
@keyframes dash {
  0% {
    stroke-dashoffset: 187;
  }
  50% {
    stroke-dashoffset: 46.75;
    -webkit-transform: rotate(135deg);
            transform: rotate(135deg);
  }
  100% {
    stroke-dashoffset: 187;
    -webkit-transform: rotate(450deg);
            transform: rotate(450deg);
  }
}
</style>